var vskoSelect = angular.module('vskoSelect', []);

vskoSelect.directive('vskoSelect', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-select.html'),
    required: ['ngModel'],
    transclude: {
      optionSlot: 'vskoOption'
    },
    scope: {
      ngModel: "=",
      options: "=",
      ngDisabled: "="
    }
  }
}]);

vskoSelect.directive('vskoOption', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-option.html'),
    replace: true,
    transclude: true,
    scope: {
      value: '@',
    }
  }
}]);
